import { useState, createContext } from "react"

export const WatchListContext = createContext()

export function WatchListContextProvider(props) {

  const [watchList, setWatchList] = useState(['GOOGL', 'MSFT', 'AMZN'])

  function addStock(stock) {
    watchList.indexOf(stock) === -1 && setWatchList([...watchList, stock])
  }

  function deleteStock(stock) {
    setWatchList(watchList.filter((el) => {
      return el !== stock
    }))
  }

  return (
  <WatchListContext.Provider
    value={{ watchList, addStock, deleteStock }}
  >
    {props.children}
  </WatchListContext.Provider>
  )
}